"use client";
import { useTranslation } from "react-i18next";
import { Container, Row, Col } from "react-bootstrap";
import Brand from "./Brand";
import getSettings from "@serie3/common/config/settings";

// The legal pages are rendered by blog-web behind the production host; the React
// app has no /legal route, so link there explicitly instead of relying on nginx.
const legalUrl = (slug) => `${getSettings().publicSiteUrl}/legal/${slug}`;

const FooterHeading = ({ children }) => (
  <p style={{ color: "#fff", fontFamily: "Montserrat, sans-serif", fontSize: 11, fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase", marginBottom: 18, opacity: 0.5 }}>
    {children}
  </p>
);

const FooterLink = ({ href, children, external }) => (
  <li style={{ marginBottom: 10, listStyle: "none" }}>
    <a
      href={href ?? "#"}
      target={external ? "_blank" : undefined}
      rel={external ? "noreferrer" : undefined}
      style={{ color: "rgba(255,255,255,0.6)", textDecoration: "none", fontSize: 14, fontFamily: "Montserrat, sans-serif", transition: "color 0.15s ease" }}
      onMouseEnter={(e) => { e.currentTarget.style.color = "#5fd0f3"; }}
      onMouseLeave={(e) => { e.currentTarget.style.color = "rgba(255,255,255,0.6)"; }}
    >
      {children}
    </a>
  </li>
);

const Footer = () => {
  const { t } = useTranslation();
  return (
    <div className="footerBackground" style={{ zIndex: 20, position: "relative" }}>
      <Container>
        <footer>
          <Row className="g-4" style={{ paddingBottom: 48 }}>
            <Col xs={12} md={5}>
              <div style={{ marginBottom: 20 }}><Brand useBlack={false} /></div>
              <p style={{ color: "rgba(255,255,255,0.55)", fontSize: 14, fontFamily: "Montserrat, sans-serif", lineHeight: 1.7, maxWidth: 280, margin: 0 }}>
                {t("Footer.Slogan")}
              </p>
              <a href="https://www.linkedin.com/company/mymediaplanner" target="_blank" rel="noreferrer"
                style={{ display: "inline-flex", alignItems: "center", gap: 8, marginTop: 24, padding: "8px 18px", borderRadius: 8, background: "rgba(255,255,255,0.07)", border: "1px solid rgba(255,255,255,0.1)", color: "rgba(255,255,255,0.75)", fontSize: 13, fontFamily: "Montserrat, sans-serif", fontWeight: 600, textDecoration: "none" }}
                onMouseEnter={(e) => { e.currentTarget.style.background = "rgba(255,255,255,0.12)"; }}
                onMouseLeave={(e) => { e.currentTarget.style.background = "rgba(255,255,255,0.07)"; }}
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6zM2 9h4v12H2z"/>
                  <circle cx="4" cy="4" r="2"/>
                </svg>
                LinkedIn
              </a>
            </Col>
            <Col xs={12} md={7}>
              <Row className="g-4">
                <Col xs={12} sm={4}>
                  <FooterHeading>Features</FooterHeading>
                  <ul style={{ padding: 0, margin: 0 }}>
                    <FooterLink>Content Recycling</FooterLink>
                    <FooterLink>Post Planning</FooterLink>
                    <FooterLink>Content Pillars</FooterLink>
                    <FooterLink>Asset Management</FooterLink>
                  </ul>
                </Col>
                <Col xs={12} sm={4}>
                  <FooterHeading>Company</FooterHeading>
                  <ul style={{ padding: 0, margin: 0 }}>
                    <FooterLink href="https://www.linkedin.com/in/felixdziekan/" external>Felix Dziekan</FooterLink>
                  </ul>
                </Col>
                <Col xs={12} sm={4}>
                  <FooterHeading>Legal</FooterHeading>
                  <ul style={{ padding: 0, margin: 0 }}>
                    <FooterLink href={legalUrl("imprint")}>{t("Footer.Imprintlink")}</FooterLink>
                    <FooterLink href={legalUrl("privacy")}>{t("Footer.Privacylink")}</FooterLink>
                    <FooterLink href={legalUrl("terms")}>{t("Footer.TermsLink")}</FooterLink>
                    <FooterLink href={legalUrl("data-deletion")}>{t("Footer.DataDeletionLink")}</FooterLink>
                  </ul>
                </Col>
              </Row>
            </Col>
          </Row>
          <div style={{ borderTop: "1px solid rgba(255,255,255,0.08)", paddingTop: 24, display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 12 }}>
            <p style={{ margin: 0, fontSize: 13, color: "rgba(255,255,255,0.35)", fontFamily: "Montserrat, sans-serif" }}>
              © {new Date().getFullYear()} Mymediaplanner. All rights reserved.
            </p>
            <div style={{ display: "flex", gap: 6 }}>
              {["#038edc", "#5fd0f3", "#51d28c"].map((c) => (
                <div key={c} style={{ width: 6, height: 6, borderRadius: "50%", background: c, opacity: 0.6 }} />
              ))}
            </div>
          </div>
        </footer>
      </Container>
    </div>
  );
};

export default Footer;
